module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAABIUlEQVQ4jY3STSvEURTH8c/MIEJDnsJiNqOmbOXhBWjKwlrxGpS1hTcjWVlKjR0bS7KThyRJ7CgPcS3mTv3nb/7Mb3Nv9577Pb9zzi34rRz6MY5RfOOtRRwIIehInY1hCaVkHK6wj+dWoFxiX8YazuKDRvYS5jCFXVymnTTUia0YnJVsEZsYSEPyMWAZDzjJgATU8IKZVAXy0UUZhxmApI5RobmXeXyiJzr5T0/oQyENaXSm2AakGAFNI8/H9RHTbUDKuE0fNiAHmEfXH4DemKiWBbnGOdYx0QIwjA28RzdNSo6qgCpmcY+LRAmTOFL/aCu4wR4+QgjN844qYgGD+MIdTvEa74ewqt7cnRDCSytIstTvjLvu6GgE239B2lEVlR+KqT/pXguYbwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/zyy/searchicon1.png
// module id = Tppo
// module chunks = 10